<template>
  <div class="pray-activity-container">
    <div class="page-header">
      <h2>祈福活动管理</h2>
    </div>

    <el-card class="form-card" shadow="hover">
      <el-form
        ref="formRef"
        :model="formData"
        :rules="formRules"
        label-width="160px"
        label-position="right"
      >
        <!-- 游戏区选择 -->
        <el-form-item label="游戏区服" prop="serverName">
          <el-select
            v-model="formData.serverName"
            placeholder="请选择游戏区"
            style="width: 350px"
            @change="onServerChange"
            clearable
          >
            <el-option
              v-for="area in areas"
              :key="area.value"
              :label="area.label"
              :value="area.label"
            />
          </el-select>
        </el-form-item>

        <!-- ========== 【新增：今日GM时间控制模块】 ========== -->
        <el-divider content-position="left">今日祈福GM时间控制（和游戏GM命令共用配置，仅当日有效）</el-divider>
        <div class="gm-rule-tips">
          <p>✅ 规则说明：</p>
          <p>1. 全服生效，一分钟内生效；次日自动恢复默认：参与08:00、开奖20:00</p>
          <p>2. 修改开奖时间会自动重置今日这一轮；一天仅开奖一次，不重置改时间不会二次开奖</p>
          <p>3. 重置：已参与玩家退还1000武侠币，清空开奖/中奖/参与记录；邮箱满20封退款暂存，下次开奖结算</p>
          <p>4. 重置是提交请求排队执行，无人在线会等待上线后执行，可查看状态</p>
          <p>5. 设置已过去的开奖时间，下一分钟直接开奖，当天无法再参与</p>
        </div>

        <el-form-item label="今日参与开始时间">
          <el-input
            v-model="gmForm.joinTimeInput"
            placeholder="格式 HH:mm，例：09:00"
            style="width:160px;margin-right:10px"
            :disabled="!formData.serverName || gmLoading.query"
          />
          <el-button type="primary" @click="handleSetJoinTime" :loading="gmLoading.setJoin" :disabled="!formData.serverName">修改参与时间</el-button>
          <el-button @click="handleResetJoinTime" :loading="gmLoading.setJoin" :disabled="!formData.serverName">恢复默认 08:00</el-button>
          <span class="tips ml10">当前：{{ gmSetting.joinTime }}（{{ gmSetting.joinIsDefault ? '默认值' : '已修改' }}）</span>
        </el-form-item>

        <el-form-item label="今日开奖时间">
          <el-input
            v-model="gmForm.drawTimeInput"
            placeholder="格式 HH:mm，例：14:30"
            style="width:160px;margin-right:10px"
            :disabled="!formData.serverName || gmLoading.query"
          />
          <el-button type="primary" @click="handleSetDrawTime" :loading="gmLoading.setDraw" :disabled="!formData.serverName">修改开奖时间（会重置本轮）</el-button>
          <el-button @click="handleResetDrawTime" :loading="gmLoading.setDraw" :disabled="!formData.serverName">恢复默认 20:00</el-button>
          <span class="tips ml10">当前：{{ gmSetting.drawTime }}（{{ gmSetting.drawIsDefault ? '默认值' : '已修改' }}）</span>
        </el-form-item>

        <el-form-item label="重置今日一轮">
          <el-button type="danger" @click="handleResetToday" :loading="gmLoading.reset" :disabled="!formData.serverName">重置今日这一轮（退款+清空记录）</el-button>
          <span v-if="gmSetting.resetPending" class="tips ml10 warning">⚠️ 重置请求排队中，等待游戏服执行，自动轮询状态</span>
          <span v-else class="tips ml10">最近重置结果：{{ gmSetting.resetResult || '暂无重置记录' }}</span>
        </el-form-item>
        <el-form-item label="刷新状态">
          <el-button type="info" @click="fetchGmSetting" :loading="gmLoading.query" :disabled="!formData.serverName">手动查询GM状态</el-button>
        </el-form-item>
        <!-- ========== 【GM模块结束】 ========== -->

        <el-divider />

        <!-- 原有活动时间配置（旧逻辑，保留不动） -->
        <el-form-item label="活动开始时间">
          <el-date-picker
            v-model="formData.startTime"
            type="datetime"
            placeholder="选择活动开始时间"
            style="width: 350px"
            :disabled="!formData.serverName"
            value-format="YYYY-MM-DD HH:mm:ss"
          />
        </el-form-item>

        <el-form-item label="活动结束时间">
          <el-date-picker
            v-model="formData.endTime"
            type="datetime"
            placeholder="选择活动结束时间"
            style="width: 350px"
            :disabled="!formData.serverName"
            value-format="YYYY-MM-DD HH:mm:ss"
          />
        </el-form-item>

        <!-- 保存时间配置按钮 -->
        <el-form-item label="操作">
          <el-button
            type="primary"
            :loading="loading.setTime"
            @click="handleSetPrayerTime"
            :disabled="!formData.serverName || !formData.startTime || !formData.endTime"
          >
            保存活动时间配置
          </el-button>
        </el-form-item>

        <el-divider />

        <!-- 今日祈福参与人员 -->
        <el-form-item label="今日祈福参与人员" prop="participantName">
          <el-select
            v-model="formData.participantName"
            placeholder="请选择中奖人员"
            style="width: 350px"
            clearable
            :disabled="!formData.serverName"
          >
            <el-option
              v-for="name in prayerNameList"
              :key="name"
              :label="name"
              :value="name"
            />
          </el-select>
          <span class="tips">选中后点击按钮设置为今日中奖者</span>
        </el-form-item>

        <!-- 设置中奖 + 清空按钮 -->
        <el-form-item label="操作">
          <el-button
            type="primary"
            :loading="loading.setWinner"
            @click="handleSetWinner"
            :disabled="!formData.participantName || !formData.serverName"
          >
            确认设置为今日中奖者
          </el-button>

          <el-button
            type="warning"
            :loading="loading.clearToday"
            @click="handleClearToday"
            :disabled="!formData.serverName"
            style="margin-left: 10px"
          >
            清空今日选中人员
          </el-button>
        </el-form-item>

        <el-divider />

        <!-- 明日活动开关 -->
        <el-form-item label="今天祈福服务器是否播报">
          <el-switch
            v-model="formData.tomorrowStatus"
            active-text="开启"
            inactive-text="关闭"
            :disabled="!formData.serverName"
            @change="handleSetTomorrowStatus"
          />
        </el-form-item>

        <el-divider />

        <!-- 奖励物品 -->
        <el-form-item label="活动奖励物品" prop="rewardName">
          <el-select
            v-model="formData.rewardName"
            placeholder="请选择奖励物品"
            style="width: 350px"
            :disabled="!formData.serverName"
          >
            <el-option
              v-for="item in rewardList"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </el-form-item>

        <!-- 保存奖品配置 -->
        <el-form-item>
          <el-button
            type="success"
            :loading="loading.setGift"
            @click="handleSaveGift"
            :disabled="!formData.rewardName || !formData.serverName"
          >
            保存奖品配置
          </el-button>
        </el-form-item>

        <el-divider />

        <!-- 补偿功能（可勾选/可取消） -->
        <el-form-item label="未祈福玩家补偿">
          <el-checkbox-group v-model="selectedGiftList">
            <el-checkbox label="高级喇叭×5" />
            <el-checkbox label="绑定鉴定丹×1" />
            <el-checkbox label="绑定2小时双倍卷轴×1" />
            <el-checkbox label="烟花×10" />
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="操作">
          <el-button
            type="danger"
            :loading="loading.giveCompensation"
            @click="handleGiveCompensation"
            :disabled="!formData.serverName"
          >
            发放补偿给未祈福玩家
          </el-button>
        </el-form-item>

      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { GAME_API } from '@/utils/apiBase';
import { ref, reactive, onMounted, onUnmounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import axios from 'axios'
import { useRouter } from 'vue-router'

const router = useRouter()
const formRef = ref(null)

// 原有加载状态
const loading = reactive({
  setWinner: false,
  setGift: false,
  setStatus: false,
  setTime: false,
  clearToday: false,
  todayData: false,
  giveCompensation: false
})

// ===== GM模块新增状态 =====
const gmLoading = reactive({
  query: false,
  setJoin: false,
  setDraw: false,
  reset: false
})
const gmForm = reactive({
  joinTimeInput: '',
  drawTimeInput: ''
})
const gmSetting = reactive({
  drawTime: '20:00',
  drawIsDefault: true,
  joinTime: '08:00',
  joinIsDefault: true,
  resetPending: false,
  resetResult: ''
})
let gmPollTimer = null // 轮询定时器

// 原有表单数据
const formData = reactive({
  serverName: '',
  participantName: '',
  tomorrowStatus: true,
  rewardName: '',
  startTime: '',
  endTime: ''
})

// 补偿勾选列表
const selectedGiftList = ref([])

// 游戏区列表
const areas = ref([])
// 祈福人员名单
const prayerNameList = ref([])
// 奖品配置
const rewardList = ref([
  { name: '七星宝箱9' },
  { name: '七星宝箱' },
  { name: '妖丹' },
  { name: '乾坤宝箓' },
  { name: '飞龙宝箱' }
])

// 表单校验
const formRules = {
  serverName: [{ required: true, message: '请选择游戏区', trigger: 'change' }],
  participantName: [{ required: true, message: '请选择中奖人员', trigger: 'change' }],
  rewardName: [{ required: true, message: '请选择奖励物品', trigger: 'change' }]
}

// 时间正则：HH:mm
const timeReg = /^([01]\d|2[0-3]):([0-5]\d)$/

// ==================================
// GM接口：查询GM配置 GetGmSetting
// ==================================
const fetchGmSetting = async () => {
  if (!formData.serverName) return
  try {
    gmLoading.query = true
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`${GAME_API}/api/PrayerSystemAdmin/GetGmSetting`, {
      params: { serverName: formData.serverName },
      headers: { 'Authorization': `Bearer ${token}` }
    })
    if (res.data.code === 200) {
      Object.assign(gmSetting, res.data.data)
      // 回填输入框
      gmForm.joinTimeInput = gmSetting.joinTime
      gmForm.drawTimeInput = gmSetting.drawTime
      // 如果排队中，开启轮询
      if (gmSetting.resetPending) {
        startPoll()
      } else {
        stopPoll()
      }
    } else {
      ElMessage.error(res.data.msg || '获取GM配置失败')
    }
  } catch (err) {
    console.error('fetchGmSetting err', err)
    if (err.response?.status === 401) {
      ElMessage.error('权限不足，请重新登录')
      router.push('/login')
    } else {
      ElMessage.error('请求GM状态接口异常')
    }
  } finally {
    gmLoading.query = false
  }
}

// 轮询：resetPending=true 每隔3秒刷新一次
const startPoll = () => {
  if (gmPollTimer) return
  gmPollTimer = setInterval(() => {
    fetchGmSetting()
  }, 3000)
}
const stopPoll = () => {
  if (gmPollTimer) {
    clearInterval(gmPollTimer)
    gmPollTimer = null
  }
}

// ==================================
// GM接口：设置参与开始时间 SetJoinTime
// ==================================
const handleSetJoinTime = async () => {
  const t = gmForm.joinTimeInput.trim()
  if (!timeReg.test(t)) {
    ElMessage.warning('时间格式必须是 HH:mm，例如 09:00')
    return
  }
  try {
    gmLoading.setJoin = true
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`${GAME_API}/api/PrayerSystemAdmin/SetJoinTime`, {
      params: { time: t, serverName: formData.serverName },
      headers: { 'Authorization': `Bearer ${token}` }
    })
    if (res.data.code === 200) {
      ElMessage.success(res.data.msg)
      fetchGmSetting()
    } else {
      ElMessage.error(res.data.msg || '设置失败')
    }
  } catch (err) {
    handleGmError(err)
  } finally {
    gmLoading.setJoin = false
  }
}
// 恢复参与时间默认 reset
const handleResetJoinTime = async () => {
  try {
    gmLoading.setJoin = true
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`${GAME_API}/api/PrayerSystemAdmin/SetJoinTime`, {
      params: { time: 'reset', serverName: formData.serverName },
      headers: { 'Authorization': `Bearer ${token}` }
    })
    if (res.data.code === 200) {
      ElMessage.success(res.data.msg)
      fetchGmSetting()
    } else {
      ElMessage.error(res.data.msg || '恢复默认失败')
    }
  } catch (err) {
    handleGmError(err)
  } finally {
    gmLoading.setJoin = false
  }
}

// ==================================
// GM接口：设置开奖时间 SetDrawTime（会自动重置本轮）
// ==================================
const handleSetDrawTime = async () => {
  const t = gmForm.drawTimeInput.trim()
  if (!timeReg.test(t)) {
    ElMessage.warning('时间格式必须是 HH:mm，例如 14:30')
    return
  }
  try {
    gmLoading.setDraw = true
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`${GAME_API}/api/PrayerSystemAdmin/SetDrawTime`, {
      params: { time: t, serverName: formData.serverName },
      headers: { 'Authorization': `Bearer ${token}` }
    })
    if (res.data.code === 200) {
      ElMessage.success(res.data.msg)
      fetchGmSetting()
    } else {
      ElMessage.error(res.data.msg || '设置开奖时间失败')
    }
  } catch (err) {
    handleGmError(err)
  } finally {
    gmLoading.setDraw = false
  }
}
// 恢复开奖时间默认 reset
const handleResetDrawTime = async () => {
  try {
    gmLoading.setDraw = true
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`${GAME_API}/api/PrayerSystemAdmin/SetDrawTime`, {
      params: { time: 'reset', serverName: formData.serverName },
      headers: { 'Authorization': `Bearer ${token}` }
    })
    if (res.data.code === 200) {
      ElMessage.success(res.data.msg)
      fetchGmSetting()
    } else {
      ElMessage.error(res.data.msg || '恢复默认失败')
    }
  } catch (err) {
    handleGmError(err)
  } finally {
    gmLoading.setDraw = false
  }
}

// ==================================
// GM接口：重置今日一轮 ResetToday
// ==================================
const handleResetToday = async () => {
  ElMessageBox.confirm(
    '⚠️ 确认重置今日这一轮？\n已参与玩家会退还1000武侠币，清空开奖、中奖、参与记录，操作提交后排队执行！',
    '危险操作确认',
    { confirmButtonText: '确认重置', cancelButtonText: '取消', type: 'warning' }
  ).then(async () => {
    try {
      gmLoading.reset = true
      const token = sessionStorage.getItem('token')
      const res = await axios.get(`${GAME_API}/api/PrayerSystemAdmin/ResetToday`, {
        params: { serverName: formData.serverName },
        headers: { 'Authorization': `Bearer ${token}` }
      })
      if (res.data.code === 200) {
        ElMessage.success(res.data.msg)
        fetchGmSetting()
      } else {
        ElMessage.error(res.data.msg || '提交重置失败')
      }
    } catch (err) {
      handleGmError(err)
    } finally {
      gmLoading.reset = false
    }
  }).catch(()=>{})
}

// GM接口统一错误处理
const handleGmError = (err) => {
  console.error('gm api err', err)
  if (err.response?.status === 401) {
    ElMessage.error('无 pray 权限，请重新登录')
    router.push('/login')
  } else {
    ElMessage.error('接口请求异常')
  }
}

// 区服切换回调
const onServerChange = () => {
  // 原有逻辑
  fetchTodayData()
  // 新增：拉取GM状态
  if (formData.serverName) {
    fetchGmSetting()
  } else {
    stopPoll()
  }
}

// ==================================
// 原有代码全部保留，不改动
// ==================================
const fetchAreas = async () => {
  try {
    const token = sessionStorage.getItem('token')
    if (!token) {
      router.push('/login')
      return
    }
    const res = await axios.get(`${GAME_API}/api/Area`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
    if (res.data.code === 200) {
      areas.value = res.data.data || []
    } else {
      ElMessage.error(`获取区服失败：${res.data.msg}`)
    }
  } catch (err) {
    console.error('获取区服异常：', err)
    ElMessage.error('获取区服数据失败')
  }
}

const fetchTodayData = async () => {
  if (!formData.serverName) {
    prayerNameList.value = []
    formData.participantName = ''
    formData.startTime = ''
    formData.endTime = ''
    formData.rewardName = ''
    formData.tomorrowStatus = true
    selectedGiftList.value = []
    return
  }

  try {
    loading.todayData = true
    const token = sessionStorage.getItem('token')
    
    const res = await axios.get(`${GAME_API}/api/PrayerSystemAdmin/GetTodayMessage`, {
      params: { serverName: formData.serverName },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    const data = res.data || ''
    const arr = data.split('|')
    
    formData.startTime = arr[0] || ''
    formData.endTime = arr[1] || ''
    const todayStatus = arr[2] || '0'
    const todayReward = arr[3] || ''
    const todayWinner = arr[4] || ''

    formData.rewardName = todayReward
    formData.participantName = todayWinner
    formData.tomorrowStatus = todayStatus === '1'

    fetchPrayerList()

  } catch (err) {
    console.error('获取今日数据异常：', err)
    ElMessage.error('获取今日活动数据失败')
  } finally {
    loading.todayData = false
  }
}

const fetchPrayerList = async () => {
  try {
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`${GAME_API}/api/PrayerSystemAdmin/GetAllPrayerName`, {
      params: { serverName: formData.serverName },
      headers: { 'Authorization': `Bearer ${token}` }
    })
    prayerNameList.value = res.data.data || []
  } catch (err) {
    ElMessage.error('获取祈福名单失败')
  }
}

const handleSetWinner = async () => {
  try {
    loading.setWinner = true
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`${GAME_API}/api/PrayerSystemAdmin/fixName`, {
      params: {
        name: formData.participantName,
        serverName: formData.serverName
      },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    if (res.data === 'success') {
      ElMessage.success('✅ 设置中奖人成功')
      fetchTodayData()
    } else {
      ElMessage.error('❌ 设置失败')
    }
  } catch (err) {
    ElMessage.error('设置接口异常')
  } finally {
    loading.setWinner = false
  }
}

const handleClearToday = async () => {
  try {
    loading.clearToday = true
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`${GAME_API}/api/PrayerSystemAdmin/ClearPrayerName`, {
      params: { serverName: formData.serverName },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    if (res.data === 'success') {
      ElMessage.success('✅ 已清空今日选中人员')
      fetchTodayData()
    } else {
      ElMessage.error('❌ 清空失败')
    }
  } catch (err) {
    ElMessage.error('清空接口异常')
  } finally {
    loading.clearToday = false
  }
}

const handleSaveGift = async () => {
  try {
    loading.setGift = true
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`${GAME_API}/api/PrayerSystemAdmin/fixPrayerGift`, {
      params: {
        name: formData.rewardName,
        serverName: formData.serverName
      },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    if (res.data === 'success') {
      ElMessage.success('✅ 奖品配置保存成功')
      fetchTodayData()
    } else {
      ElMessage.error('❌ 保存失败')
    }
  } catch (err) {
    ElMessage.error('奖品接口异常')
  } finally {
    loading.setGift = false
  }
}

const handleSetTomorrowStatus = async (val) => {
  if (!formData.serverName) {
    ElMessage.warning('请先选择游戏区')
    formData.tomorrowStatus = !val
    return
  }

  try {
    loading.setStatus = true
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`${GAME_API}/api/PrayerSystemAdmin/fixPrayerIsEnd`, {
      params: {
        isEnd: val ?  0: 1,
        serverName: formData.serverName
      },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    if (res.data === 'success') {
      ElMessage.success(`✅ 已${val ? '开启' : '关闭'}明日活动`)
    } else {
      ElMessage.error('❌ 状态设置失败')
      formData.tomorrowStatus = !val
    }
  } catch (err) {
    ElMessage.error('状态接口异常')
    formData.tomorrowStatus = !val
  } finally {
    loading.setStatus = false
  }
}

const handleSetPrayerTime = async () => {
  if (!formData.serverName) {
    ElMessage.warning('请先选择游戏区')
    return
  }
  if (!formData.startTime || !formData.endTime) {
    ElMessage.warning('请选择完整的活动开始和结束时间')
    return
  }

  try {
    loading.setTime = true
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`${GAME_API}/api/PrayerSystemAdmin/fixPrayerTime`, {
      params: {
        StartTime: formData.startTime,
        Endtime: formData.endTime,
        serverName: formData.serverName
      },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    if (res.data === 'success') {
      ElMessage.success('✅ 活动时间配置保存成功')
      fetchTodayData()
    } else {
      ElMessage.error('❌ 时间配置保存失败')
    }
  } catch (err) {
    ElMessage.error('时间配置接口请求失败')
  } finally {
    loading.setTime = false
  }
}

const handleGiveCompensation = async () => {
  if (!formData.serverName) {
    ElMessage.warning('请先选择游戏区')
    return
  }

  try {
    loading.giveCompensation = true
    const token = sessionStorage.getItem('token')
    const sendName = selectedGiftList.value.join(',')
    const res = await axios.get(`${GAME_API}/api/PrayerSystemAdmin/fixPrayerConpensationGift`, {
      params: {
        name: sendName,
        serverName: formData.serverName
      },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    if (res.data === 'success') {
      ElMessage.success('✅ 补偿发放成功！')
    } else {
      ElMessage.error('❌ 发放失败')
    }
  } catch (err) {
    ElMessage.error('补偿接口异常')
  } finally {
    loading.giveCompensation = false
  }
}

onMounted(() => {
  fetchAreas()
})
onUnmounted(()=>{
  stopPoll()
})
</script>

<style scoped>
.pray-activity-container {
  padding: 24px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  margin: 0;
  font-size: 22px;
  color: #1f2329;
  font-weight: 600;
}

.form-card {
  max-width: 800px;
  padding: 20px;
}

.tips {
  margin-left: 12px;
  color: #909999;
  font-size: 12px;
}
.ml10 {
  margin-left:10px;
}
.warning {
  color: #E6A23C !important;
}
.gm-rule-tips {
  background-color: #fdf6ec;
  padding:12px 16px;
  border-radius:6px;
  font-size:13px;
  color:#606266;
  line-height:1.6;
  margin-bottom:16px;
}
.gm-rule-tips p {
  margin:4px 0;
}
:deep(.el-form-item) {
  margin-bottom: 24px;
}
</style>
